app.component("recipientCornea", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/recipientCornea/recipientCornea.html",
	controller: "recipientCorneaController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("recipientCorneaController", [
	"$scope",
	function ($scope) {
		this.$onInit = function () {};

		$scope.hostTrephineOptions = [
			{ value: "SIZE_6_00", name: "6.00" },
			{ value: "SIZE_6_25", name: "6.25" },
			{ value: "SIZE_6_50", name: "6.50" },
			{ value: "SIZE_6_75", name: "6.75" },

			{ value: "SIZE_7_00", name: "7.00" },
			{ value: "SIZE_7_25", name: "7.25" },
			{ value: "SIZE_7_50", name: "7.50" },
			{ value: "SIZE_7_75", name: "7.75" },

			{ value: "SIZE_8_00", name: "8.00" },
			{ value: "SIZE_8_25", name: "8.25" },
			{ value: "SIZE_8_50", name: "8.50" },
			{ value: "SIZE_8_75", name: "8.75" },

			{ value: "SIZE_9_00", name: "9.00" },
			{ value: "SIZE_9_25", name: "9.25" },
			{ value: "SIZE_9_50", name: "9.50" },
			{ value: "SIZE_9_75", name: "9.75" },
			{ value: "SIZE_10_00", name: "10.00" },

			{ value: "OTHER", name: "Other (specify)" },
		];

		$scope.hostTrephineTypeOptions = [
			{ value: "MANUAL_NON_VACUUM", name: "Manual (Non-Vacuum)" },
			{ value: "VACUUM", name: "Vacuum (e.g., Hessburg-Barron)" },
			{ value: "FEMTOSECOND_LASER", name: "Femtosecond Laser" },
			{ value: "OTHER", name: "Other (specify)" },
		];

		$scope.targetIntendedOptions = [
			{ value: "PUPIL_CENTER", name: "Pupil Center" },
			{ value: "CORNEAL_APEX_VISUAL_AXIS", name: "Corneal Apex/Visual Axis" },
			{ value: "OVERLYING_SCAR", name: "Overlying Scar" },
			{ value: "ECTASIA", name: "Ectasia" },
			{ value: "OTHER", name: "Other (specify)" },
		];

		$scope.decentrationOptions = [
			{ value: "NONE", name: "None (Centered on Target)" },
			{ value: "NASAL", name: "Nasal" },
			{ value: "TEMPORAL", name: "Temporal" },
			{ value: "SUPERIOR", name: "Superior" },
			{ value: "INFERIOR", name: "Inferior" },
		];

		$scope.centrationOptions = [
			{ value: "ON_TARGET", name: "On Target" },
			{ value: "SLIGHTLY_DECENTERED", name: "Slightly Decentered" },
			{ value: "SIGNIFICANTLY_DECENTERED", name: "Significantly Decentered" }
		];

        $scope.quadrantTypeOptions = [
			{ value: "NONE", name: "None (0)" },
			{ value: "ONE", name: "1" },
			{ value: "TWO", name: "2" },
			{ value: "THREE", name: "3" },
			{ value: "FOUR", name: "4" },
		];
	},
]);